import InputTag from './InputTag.vue'

export { InputTag }

export default InputTag



// WEBPACK FOOTER //
// ./src/index.js